import { useEffect, useRef, useState } from "react";

type Size = {
  width: number;
  height: number;
};

type UseResizeObserverReturn<T extends HTMLElement = HTMLElement> = [
  React.RefObject<T | null>,
  Size,
];

const useResizeObserver = <T extends HTMLElement = HTMLElement>(): UseResizeObserverReturn<T> => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const updateSize = () => {
      if (ref.current) {
        const { width, height } = ref.current.getBoundingClientRect();
        setSize({ width, height });
      }
    };

    updateSize();

    const observer = new ResizeObserver(() => {
      updateSize();
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return [ref, size];
};

export default useResizeObserver;
